import { render } from "./AuthorityForm.vue?vue&type=template&id=30e88a43&scoped=true"
import script from "./AuthorityForm.vue?vue&type=script&lang=ts"
export * from "./AuthorityForm.vue?vue&type=script&lang=ts"

import "./AuthorityForm.vue?vue&type=style&index=0&id=30e88a43&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30e88a43"

export default script